export default __webpack_public_path__ + "static/media/port-move.b6f07caa.webp";